/**
 * A THROUGHPUT SPARKLINE — one trend line (Linear-style), the last point (this
 * week) emphasised in the app's own accent. Never a cumulative-flow diagram:
 * "the chart is the evidence, the sentence beside it is the answer", so a reading
 * line always sits next to this. Pure presentation — it draws whatever weekly
 * counts it is handed and knows nothing of where they came from.
 */
export default function Spark({ values, w = 58, h = 18 }: { values: number[]; w?: number; h?: number }) {
  const n = values.length;
  if (n === 0) return null;
  const max = Math.max(1, ...values);
  // Inset the plot by the end-dot's radius (plus a hair) so a dot at the top or
  // right edge — the common case for a rising trend ending on its highest point —
  // is never clipped by the viewBox.
  const r = h / 8;
  const m = r + 1;
  const px = (i: number) => (n === 1 ? 0 : (i / (n - 1)) * (w - 2 * m)) + m;
  const py = (v: number) => h - m - (v / max) * (h - 2 * m);
  const pts = values.map((v, i) => `${px(i).toFixed(1)},${py(v).toFixed(1)}`).join(' ');
  const lx = px(n - 1).toFixed(1);
  const ly = py(values[n - 1]).toFixed(1);
  return (
    <svg className="mv-spark" width={w} height={h} viewBox={`0 0 ${w} ${h}`} aria-hidden="true">
      <polyline className="ln" points={pts} />
      <circle className="end" cx={lx} cy={ly} r={r.toFixed(1)} />
    </svg>
  );
}
